import { render, staticRenderFns } from "./newBanner.vue?vue&type=template&id=f2c01cc4&scoped=true"
import script from "./newBanner.vue?vue&type=script&lang=js"
export * from "./newBanner.vue?vue&type=script&lang=js"
import style0 from "./newBanner.vue?vue&type=style&index=0&id=f2c01cc4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c01cc4",
  null
  
)

export default component.exports